"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useProfileInterests", {
    enumerable: true,
    get: ()=>useProfileInterests
});
const _react = require("react");
const _index = require("./../../index");
const useProfileInterests = ()=>{
    const [interest, setInterest] = (0, _react.useState)();
    const { member , walletId , demoMode  } = (0, _index.useSpringBigStore)();
    const { mutate: updateMember , isLoading: updateIsLoading  } = (0, _index.useUpdateMember)();
    const { refetch: fetchMember , isLoading: memberIsLoading  } = (0, _index.useGetMember)();
    (0, _react.useEffect)(()=>{
        if (member) {
            setInterest(member.interests);
        }
    }, [
        member
    ]);
    const handleInterest = (0, _react.useCallback)((name)=>{
        if (!name) {
            return;
        }
        const payload = {
            member: {
                id: member.id
            },
            interest_list: ''
        };
        let interestList = [];
        const checkedInterest = member && member.interests ? member.interests.filter((el)=>el.checked)?.map((el)=>el.name) : [];
        if (checkedInterest && checkedInterest.includes(name)) {
            interestList = checkedInterest.filter((data)=>data !== name);
            _index.observer.emit('profile-deselect-interest', {
                walletId: walletId,
                interest: name
            });
        } else {
            interestList = checkedInterest && checkedInterest.length > 0 ? [
                ...checkedInterest,
                name
            ] : [
                name
            ];
            _index.observer.emit('profile-select-interest', {
                walletId: walletId,
                interest: name
            });
        }
        if (demoMode && payload.member) {
            member && member.interests && member.interests?.length > 0 && member.interests.map((interest, index)=>{
                member.interests[index].checked = member.interests && member.interests[index].name && interestList.includes(member.interests[index].name);
            });
            payload.member = member;
        }
        payload.interest_list = [
            ...interestList
        ].join(',');
        updateMember(payload);
    }, [
        member,
        updateMember
    ]);
    return {
        member,
        interest,
        updateIsLoading,
        memberIsLoading,
        fetchMember,
        handleInterest
    };
};
